
import * as CircleVertical from './circle-vertical';
import * as CircleHorizontal from './circle-horizontal';
import * as Fanchart from './fanchart';
import * as HalfCircle from './half-circle';
import * as HalfCircleInverted from './half-circle-inverted';

export default {
  'fanchart': Fanchart,
  'circle-vertical': CircleVertical,
  'circle-horizontal': CircleHorizontal,
  'half-circle': HalfCircle,
  'half-circle-inverted': HalfCircleInverted,
}


// WEBPACK FOOTER //
// ./src/core/templates/index.js